import React from 'react';
export function Footer() {
  return <footer className="bg-[#071A33] px-3 py-3 text-center sm:px-6" data-id="element-63" data-mp="32wd2qgad7ltj">
      <p className="mx-auto max-w-2xl text-[0.62rem] leading-[1.45] text-white/60 sm:text-[0.72rem]" data-id="element-64" data-mp="3gfiyquovsxjx">
        © 2026 ULTRASOUND VISUAL ATLAS™ — All Rights Reserved. ULTRASOUND VISUAL
        ATLAS™ is an educational study and reference resource. It does not
        replace formal ultrasound education, supervised clinical training,
        professional medical advice, diagnosis or qualified clinical judgment.
      </p>
      <p className="mt-1 text-[0.62rem] text-white/70 sm:text-[0.72rem]" data-id="element-65" data-mp="387drhtbj3d5">
        <a href="#" className="hover:text-white" data-id="element-66" data-mp="3lf5bl30ssbs7">Terms &amp; Conditions</a> •{' '}
        <a href="#" className="hover:text-white" data-id="element-67" data-mp="3qcxbaj7op26y">Privacy Policy</a> • Contact
        Support:{' '}
        <a href="mailto:kitonline27@gmail.com" className="hover:text-white" data-id="element-68" data-mp="29ynnbq7ctfgn">
          kitonline27@gmail.com
        </a>
      </p>
    </footer>;
}